// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"b2-z","displaySixCardTiles":"c2-z"};